import { connect } from 'react-redux';
import ProcessDisplay from './ProcessDisplay';

const mapStateToProps = (state) => {
  const {
    processes: { all },
    request: { progress },
  } = state;

  return {
    processes: all,
    progress,
  };
};

export default connect(mapStateToProps)(ProcessDisplay);
